import { FornecedorService } from 'src/app/service/fornecedor-service';
import { ClienteService } from 'src/app/service/cliente-service';
import { AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { PoBreadcrumb, PoLookupColumn, PoModalAction, PoModalComponent, PoNotificationService, PoPageAction, PoPageFilter, PoTableAction, PoTableColumn, PoTableComponent, PoDialogService } from '@po-ui/ng-components';
import { AuthService } from 'src/app/service/auth.service';
import { NetrinService } from '../service/netrin.service';
import { defaultIntegracaoNetrin, IntegracaoNetrin } from '../interface/dados-cliente-fornecedor';
import { JsonEditorOptions } from 'ang-jsoneditor';
import { Cliente, getClienteDefault } from 'src/app/interface/cliente';
import { Fornecedor, getFornecedorDefault } from 'src/app/interface/fornecedor';
import { FiltroDadosNetrinAtualizacao } from '../interface/filtro-dados-netrin';
import { ClienteLookupService } from 'src/app/service/cliente-lookup-service';
import { FornecedorLookupService } from 'src/app/service/fornecedor-lookup-service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-administrativo-netrin-atualizacao-cadastro',
  templateUrl: './administrativo-netrin-atualizacao-cadastro.component.html',
  styleUrls: ['./administrativo-netrin-atualizacao-cadastro.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AdministrativoNetrinAtualizacaoCadastroComponent implements OnInit  {

  tabelaPrincipalDados: Array<IntegracaoNetrin> = [];

  jsonEditorOptions: JsonEditorOptions = new JsonEditorOptions();
  dadosEmAtualizacao: IntegracaoNetrin = defaultIntegracaoNetrin();

  dadosCliente: Cliente = getClienteDefault();
  dadosFornecedor: Fornecedor = getFornecedorDefault();

  tabelaPrimariaFiltro: FiltroDadosNetrinAtualizacao = new FiltroDadosNetrinAtualizacao(this.authService, 'AdministrativoNetrinAtualizacaoCadastroComponent');

  fornecedorColumnsFilters: Array<PoLookupColumn> = this.fornecedorLookupService.getColumnsFilter();
  clientecolumnsFilters: Array<PoLookupColumn> = this.clienteLookupService.getColumnsFilter();

  constructor(
    public clienteLookupService: ClienteLookupService,
    public fornecedorLookupService: FornecedorLookupService,
    private authService: AuthService,
    private netrinService: NetrinService,
    private clienteService: ClienteService,
    private poDialogService: PoDialogService,
    private fornecedorService: FornecedorService,
    private poNotificationService: PoNotificationService,
  ) { }


  @ViewChild('modalDadosErro', { static: true }) modalDadosErro!: PoModalComponent;
  @ViewChild('modalVerProcesso', { static: true }) modalVerProcesso!: PoModalComponent;
  @ViewChild('tabelaPrincipal', {static: false}) tabelaPrincipal!: PoTableComponent;
  @ViewChild('modalFiltroAvancadoTabelaPrincipal', {static: false}) modalFiltroAvancadoTabelaPrincipal!: PoModalComponent;

  public readonly poPageBreadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Início', link: '/' },
      { label: 'Administrativo', },
      { label: 'Netrin', },
      { label: 'Atualizar Cadastro (Cliente e Fornecedor)' }
    ]
  };

  public readonly poPageActions: Array<PoPageAction> = [
    { label: 'Salvar Cadastros', action: this.atualizarCadastro.bind(this) }
  ];

  public readonly poPoPageFilter: PoPageFilter = {
    advancedAction: ()=> this.modalFiltroAvancadoTabelaPrincipal.open()
  }

  public tabelaPrincipalColumns: Array<PoTableColumn> = [

    {property: 'CCODIGO'        , label: 'Código'                 , type: 'number'},
    {property: 'CLOJA'          , label: 'Loja'                                   },
    { property: 'CTIPO'         , label: 'Tipo'                   , type: 'label'
      , labels: [
        {value: 'C', color: '#00c983', label: 'Cliente'},
        {value: 'F', color: '#00c9b5', label: 'Fornecedor'}
      ]
    },
    {property: 'CCGC'           , label: 'CNPJ/CPF'                               },
    {property: 'CNOME'          , label: 'Nome'                                   },
    {property: 'CNOMEFANTASIA'  , label: 'Nome Fantasia'                          },
    { property: 'CJAINCLUIDO'   , label: 'Incluído'       , type: 'label'
      , labels: [
        {value: 'S', color: 'color-09', label: 'Sim'},
        {value: 'N', color: 'color-08', label: 'Não'}
      ]
    },
    { property: 'CSTATUS'       , label: 'Status'                   , type: 'label'
      , labels: [
        {value: 'A', color: 'color-02', label: 'Aguardando Análise'},
        {value: 'E', color: 'color-08', label: 'Erro' },
        {value: 'F', color: 'color-12', label: 'Análise Finalizada'},
      ]
    },
    {property: 'DDATAINCLUSAO'  , label: 'Data Inclusão'            , type: 'date'},
    {property: 'DDATAATULIZACAO', label: 'Data Ultima Atualização'  , type: 'date'},
  ];

  public readonly tabelaPrincipalActions: Array<PoTableAction> = [
    { label: 'Visualizar', action: this.actionVisualizarProcesso.bind(this), icon: 'po-icon-eye'  },
    { label: 'Ver Erro', action: this.actionVisualizarErroProcesso.bind(this), icon: 'po-icon-picker'   , visible: (row:IntegracaoNetrin) => (row.CSTATUS === 'E') }
  ];

  ngOnInit() {
    this.jsonEditorOptions.modes = ['view'];
    this.jsonEditorOptions.mode  = 'view';

    this.tabelaPrimariaFiltro.init().then(()=>{
      this.tabelaPrincipalColumns = this.tabelaPrimariaFiltro.atualizarColumnsManager(this.tabelaPrincipalColumns);
      this.loadDados();
    });
  }

  loadDados(): void {
    this.netrinService.getDadosIntegracaoLista(this.tabelaPrimariaFiltro.dados).subscribe((res) => {
      this.tabelaPrincipalDados = [...res.items];
    });
  }

  actionVisualizarProcesso(row: IntegracaoNetrin): void {

    this.compararDadosIntergrao(row);

    this.modalVerProcesso.open();
  }

  async compararDadosIntergrao(row: IntegracaoNetrin): Promise<void> {
    this.dadosCliente       = getClienteDefault();
    this.dadosFornecedor    = getFornecedorDefault();
    this.dadosEmAtualizacao = defaultIntegracaoNetrin();

    if (row.CTIPO === "C") {
      const res = await firstValueFrom(this.clienteService.getCliente(row.CCODIGO + row.CLOJA, 'C'));

      this.dadosCliente = { ...res };
      this.dadosEmAtualizacao.NRECNO = res.NA1RECNO;
    } else {
      const res = await firstValueFrom( this.fornecedorService.getFornecedor(row.CCODIGO + row.CLOJA, 'C'));

      this.dadosFornecedor = { ...res };
      this.dadosEmAtualizacao.NRECNO = res.NA2RECNO;
    }

    if (row.CCOMANALISE === 'S') {
      this.dadosEmAtualizacao = { ...row };
      this.modalVerProcesso.open();
      return;
    }

    this.dadosEmAtualizacao             = { ...this.dadosEmAtualizacao, ...row };
    this.dadosEmAtualizacao.CSIMPNAC    = ' ';
    this.dadosEmAtualizacao.CCOMANALISE = 'S';
    this.dadosEmAtualizacao.CATIVO      = ' ';

    const dadosSintegra        = {...row.OJSONDADOS?.sintegra};
    const dadosReceitaFederal  = {...row.OJSONDADOS?.receitaFederal};
    const dadosSimplesNacional = {...row.OJSONDADOS?.simplesNacional};

    if (dadosSintegra?.inscricoesEstaduais && dadosSintegra?.inscricoesEstaduais?.length > 0) {
      const inscricoesAtivas = dadosSintegra.inscricoesEstaduais.filter(i =>  ['ATIVO','ATIVA','HABILITADO', 'HABILITADA'].includes(new String(i.situacaoCadastral).toLocaleUpperCase())).sort((a, b) => new Date(b.dataSituacaoCadastral).getTime() - new Date(a.dataSituacaoCadastral).getTime());

      const dadosSintegraAtivo = inscricoesAtivas.length > 0 ? { ...inscricoesAtivas[0] } : null;

      this.dadosEmAtualizacao.CNOME         = this.getValorCampo(dadosSintegraAtivo?.razaoSocial, dadosReceitaFederal?.razaoSocial, 59,'');
      this.dadosEmAtualizacao.CNOMEFANTASIA = this.getValorCampo(dadosSintegraAtivo?.nomeFantasia, dadosReceitaFederal?.nomeFantasia, 19, '');
      this.dadosEmAtualizacao.CEND          = this.getValorCampo(dadosSintegraAtivo?.logradouro, dadosReceitaFederal?.logradouro, 59,'');
      this.dadosEmAtualizacao.CEND         += ', ' + this.getValorCampo(dadosSintegraAtivo?.numero, dadosReceitaFederal?.numero, undefined, 'S/Nº');
      this.dadosEmAtualizacao.CCOMPLEM      = this.getValorCampo(dadosSintegraAtivo?.complemento, dadosReceitaFederal?.complemento, 49, '');
      this.dadosEmAtualizacao.CMUN          = this.getValorCampo(dadosSintegraAtivo?.municipio, dadosReceitaFederal?.municipio, 59, '');
      this.dadosEmAtualizacao.CCEP          = this.removerHifenPonto(this.getValorCampo(dadosSintegraAtivo?.cep, dadosReceitaFederal?.cep, 10, ''));
      this.dadosEmAtualizacao.CATIVO        = this.getValorCampo(dadosSintegraAtivo?.situacaoCadastral, dadosReceitaFederal?.situacaoCadastral, undefined, '');
      this.dadosEmAtualizacao.CINSCR        = this.removerHifenPonto(this.validaCampoApiVazio(dadosSintegraAtivo?.inscricaoEstadual)).substring(0, 17) || 'ISENTO';

    } else if (Object.keys(dadosReceitaFederal).length > 0) {
      this.dadosEmAtualizacao.CNOME         = this.getValorCampo(dadosReceitaFederal?.razaoSocial   , '', 59, '');
      this.dadosEmAtualizacao.CNOMEFANTASIA = this.getValorCampo(dadosReceitaFederal?.nomeFantasia  , '', 19, '');
      this.dadosEmAtualizacao.CEND          = this.getValorCampo(dadosReceitaFederal?.logradouro    , '', 59, '');
      this.dadosEmAtualizacao.CEND          += ', ' + this.getValorCampo(dadosReceitaFederal?.numero, '', undefined, 'S/Nº');
      this.dadosEmAtualizacao.CCOMPLEM      = this.getValorCampo(dadosReceitaFederal?.complemento   , '', 49, '');
      this.dadosEmAtualizacao.CMUN          = this.getValorCampo(dadosReceitaFederal?.municipio     , '', 59, '');
      this.dadosEmAtualizacao.CCEP          = this.getValorCampo(dadosReceitaFederal?.cep           , '', 10, '');
      this.dadosEmAtualizacao.CATIVO        = dadosReceitaFederal?.situacaoCadastral || this.dadosCliente.CA1MSBLQL || this.dadosFornecedor.CA2MSBLQL;
      this.dadosEmAtualizacao.CINSCR        = 'ISENTO';
    }

    if (dadosSimplesNacional) {
      this.dadosEmAtualizacao.CSIMPNAC = dadosSimplesNacional.situacaoSimplesNacional ? ['NÃO','NAO'].includes(dadosSimplesNacional.situacaoSimplesNacional) ? '1' : '2' : ' ';
    }

    return;
  }


  salvaItemAnalisado(): void {
    const item = {...this.dadosEmAtualizacao};

    this.tabelaPrincipalDados = this.tabelaPrincipalDados.map((row) => (row.NID == item.NID ? {...item, LANALISADO: true} : row));

    this.modalVerProcesso.close();
  }


  getValorCampo( campoSintegra: string | undefined, campoReceita: string | undefined, maxLength?: number, valorPadrao: string = ''): string {
    const valor = new String(this.validaCampoApiVazio(campoSintegra) || this.validaCampoApiVazio(campoReceita) || valorPadrao || '').toString();

    return maxLength ? valor.substring(0, maxLength) : valor.toString();
  }

  async atualizarCadastro() {

    const items = this.tabelaPrincipal.getSelectedRows() as Array<IntegracaoNetrin>;

    if (items.length <= 0) {
      this.poNotificationService.warning('Selecione pelo menos um registro para atualizar.');
      return;
    }

    let itemsProcessados = [...items];

    for (const item of items) {
      if (item.CCOMANALISE !== 'S') {

        await this.compararDadosIntergrao(item);

        itemsProcessados = itemsProcessados.map((row) => row.NID === item.NID ? this.dadosEmAtualizacao : row);
      }
    }

    this.poDialogService.confirm({
      title: 'Atualizar cadastro(s)',
      message: 'Deseja realmente atualizar o cadastro(s) selecionado(s)?',
      confirm: ()=> {
        this.netrinService.postAtualizarClienteFornecedor({items: itemsProcessados}).subscribe(() => {
          this.loadDados();
          this.modalVerProcesso.close();
        });
      },
      cancel: ()=> {
        this.modalVerProcesso.close();
      }
    })

  }


  salvarColunas(): void {
    this.tabelaPrimariaFiltro.dados.ACOLUNAS = this.tabelaPrincipal['_columns'];
    this.tabelaPrimariaFiltro.postSalvarFiltro();
  }

  validaCampoApiVazio(texto: string = ''): string {
    //@ts-ignore
    return texto.trim().replaceAll('*',' ').trim() ? texto.toLocaleUpperCase() : '' ;
  }

  removerHifenPonto(texto: string = ''): string {
    return texto.replace(/[-.]/g, '');
  }

  actionVisualizarErroProcesso(row: IntegracaoNetrin): void {
    this.dadosEmAtualizacao = {...row};
    this.modalDadosErro.open();
  }

  public readonly modalFiltroAvancadoTabelaPrincipalActions: PoModalAction = {
    label: 'Aplicar Filtros',
    action: ()=> {
      this.modalFiltroAvancadoTabelaPrincipal.close();
      this.tabelaPrimariaFiltro.postSalvarFiltro();
      this.loadDados();
    }
  }
}
